__turbopack_context__.v({
  "flexCenter": "_9B6uRG_flexCenter",
  "leftIcon": "_9B6uRG_leftIcon",
  "optionContent": "_9B6uRG_optionContent",
  "rightIcon": "_9B6uRG_rightIcon",
  "tooltip": "_9B6uRG_tooltip",
});
